






















export default {
	name: 'Paginate',

	props: {
		next: {
			required: false,
			type: String,
		},
		prev: {
			required: false,
			type: String,
		},
	},

	methods: {
		async goToPage(page) {
			this.$emit('page', page);
		},
	},
};
